import { useState, useEffect } from 'react';
import { MeetingDetail as MeetingDetailClassic } from './MeeingDetailClassic';
import { MeetingDetail as MeetingDetailCard } from './MeetingDetailCard';

type LayoutType = 'classic' | 'card';

export function MeetingDetail() {
  // Get initial layout from localStorage or default to 'card'
  const [layout, setLayout] = useState<LayoutType>(() => {
    const saved = localStorage.getItem('meetingDetailLayout');
    return (saved as LayoutType) || 'card';
  });

  // Persist layout preference to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('meetingDetailLayout', layout);
  }, [layout]);

  const toggleLayout = () => {
    setLayout(prev => prev === 'classic' ? 'card' : 'classic');
  };

  return (
    <>
      {/* Render the selected layout with layout state and toggle function */}
      {layout === 'classic' ? (
        <MeetingDetailClassic layout={layout} onToggleLayout={toggleLayout} />
      ) : (
        <MeetingDetailCard layout={layout} onToggleLayout={toggleLayout} />
      )}
    </>
  );
}
